module.exports = __webpack_public_path__ + "img/no-order.12f3ce36.png";